import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { TasksState } from './TasksState';

// How many tasks were made from a note, kept current as tasks change.
export const useNoteTaskCount = (noteId: string): number => {
    const tasksState = useInstance(TasksState);
    useSubscription(() => tasksState);

    return tasksState.getTasks().filter(task => task.source?.noteId === noteId).length;
};
